<template>
  <div :class="className"
       :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data () {
    return {
      chart: null,
      xArr1: [48, 208, 1719],
      xArr2: [92, 449, 1782],
      xArr3: [91, 359, 1818],
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        // this.setOptions(val);
      },
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy () {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions (data) {
      console.log("往年预青数据",data)
      let _this = this;
      let setOptionStyle = {
        tooltip: {
          trigger: "axis",
          formatter (params) {
            // console.log('params', params)
            var aaaa = ''
            for (let x = 0; x < params.length; x++) {
              for (var key in data.legendData) {
                if (params[x].seriesName === data.legendData[key]) {
                  aaaa += `<div style='color: #fff'>${params[x].seriesName}${params[x].axisValueLabel} :${params[x].data}人犯罪率：${((params[x].data / _this.xArr1[2]) * 100).toFixed(2)}%</div>`
                }
              }
            }
            return aaaa
          }
        },
        legend: {
          data: data.legendData,
          right: 0,
          textStyle: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        color: ['red', 'green', 'blue'],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          // boundaryGap: false,
          data: ["未成年犯罪嫌疑人数", "25岁以下青少年犯罪嫌疑人人数", "全部犯罪嫌疑人人数"],
        },
        yAxis: {
          type: "value",
          splitArea: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "#333",
          },
          splitLine: {
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "2017年",
            type: "line",
            stack: "总量",
            data: [48, 208, 1719],
            smooth: 0,
          },
          {
            name: "2018年",
            type: "line",
            stack: "总量",
            data: [92, 449, 1782],
            smooth: 0,
          },
          {
            name: "2019年",
            type: "line",
            stack: "总量",
            data: [91, 359, 1818],
            smooth: 0,
          },
        ],
      }
      setOptionStyle.series = []
      for (var key in data.seriesList) {
        let seriesList = {
          name: "2020年",
          type: "line",
          stack: "总量",
          data: [36, 186, 1154],
          smooth: 0,
        }
        seriesList.name = data.seriesList[key].name;
        seriesList.data = data.seriesList[key].data;
        setOptionStyle.series.push(seriesList);
      }
      this.chart.setOption(setOptionStyle);
    },
  },
};
</script>
